module.exports = __webpack_public_path__ + "static/media/united-states.a6e1be5c.svg";